import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class DocumentItemPair {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  settlementAmountCurrency!: string;
  @IsNumber()
  @Expose()
  settlementAmountInCurrency!: number;
  @IsOptional()
  @IsString()
  @Expose()
  documentNumber!: string | null;
  @IsNumber()
  @Expose()
  currencyTranslationDifference!: number;
  @IsBoolean()
  @Expose()
  writeOff!: boolean;
  @IsNumber()
  @Expose()
  settlementAmount!: number;
  @IsNumber()
  @Expose()
  purchaseNetPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  costDifference!: number;
  @IsString()
  @Expose()
  purchaseNetPriceCurrency!: string;
  @IsBoolean()
  @Expose()
  isSettled!: boolean;
  @IsBoolean()
  @Expose()
  isCostDifferencePosition!: boolean;
  @IsBoolean()
  @Expose()
  isRelatedWithMany!: boolean;
}

export class CostDocumentItemsPair {
  @IsNumber()
  @Expose()
  id!: number;
  @IsOptional()
  @Expose()
  @IsString()
  documentNumber!: string | null;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsNumber()
  @Expose()
  pairedAmount!: number;
  @IsNumber()
  @Expose()
  costDifference!: number;
  @IsNumber()
  @Expose()
  exchangeRateDifferences!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsOptional()
  @IsString()
  @Expose()
  pairedCurrency!: string | null;
  @IsBoolean()
  @Expose()
  isSettled!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  comment!: string | null;
}

export class CostDocumentItemsPairSimple {
  @IsString()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  costDifference!: number;
}

export class CostDocumentItemsPairs {
  @IsNumber()
  @Expose()
  margin!: number;
  @IsNumber()
  @Expose()
  documentItemCostDifference!: number;
  @Type(() => CostDocumentItemsPair)
  @ValidateNested()
  @Expose()
  costDocumentItems!: Array<CostDocumentItemsPair>;
  @Type(() => DocumentItemPair)
  @ValidateNested()
  @Expose()
  pairDocumentItems!: Array<DocumentItemPair>;
}

export type CostDocumentItemsPairsResponse = Array<CostDocumentItemsPairs>;
